<template>
  <div class="flex items-center">
    <!--    <vs-avatar-->
    <!--      :src="params.data.avatar"-->
    <!--      class="flex-shrink-0 mr-2"-->
    <!--      size="30px"-->
    <!--      @click="$router.push(url)"-->
    <!--    />-->
    <!--    <div id="avatar-col" class="vx-col">-->
    <!--      <div class="img-container">-->
    <!--        <img-->
    <!--          :src="imgSrc"-->
    <!--          class="rounded w-full"-->
    <!--        />-->
    <!--      </div>-->
    <!--    </div>-->
    <router-link
      :to="url"
      @click.stop.prevent
      class="text-inherit hover:text-primary"
      >{{ params.value }}</router-link
    >
  </div>
</template>

<script>
export default {
  name: "CellRendererLink",
  data() {
    return {
      imgSrc: require("@/assets/images/sample/ship_images01.jpg"),
    };
  },
  computed: {
    url() {
      return "/enterprise/management/vessel-view/" + this.params.data.id;
    },
  },
};
</script>
